$.fn.PackagesItem = function() {
  let self = this
  self.button = self.find('.package-item__see-more')
  self.content = self.find('.package-item__content')
  self.expanded = false

  self.update = function() {
    self.expanded = false
    self.button.attr('aria-expanded', 'false')
    self.content.attr('aria-hidden', 'true').hide()
  }

  self.clicked = function() {
    if (self.expanded) {
      self.expanded = false;
      self.button.attr('aria-expanded', 'false')
      self.content.slideUp(425, 'easeInOutQuart', function() {
        self.content.attr('aria-hidden', 'true')
      });
      if ($.mlmi.mobile.isMobile) {
        $('html, body').scrollTo(self.offset().top - $('.header').outerHeight(false) - 20, 450, 5, 'easeInOutQuart')
      }
    } else {
      self.expanded = true;
      self.button.attr('aria-expanded', 'true')
      self.content.hide().attr('aria-hidden', 'false')
      self.content.slideDown(425, 'easeInOutQuart');
      if ($.mlmi.mobile.isMobile) {
        $('html, body').scrollTo(self.find('.package-item__details').offset().top - $('.header').outerHeight(false) - 20, 450, 5, 'easeInOutQuart')
      }
    }
  }

  return function() {
    self.button.on('click', self.clicked)
    self.update()
    return self
  }()
}

$.fn.Packages = function() {
  let self = this

  if (self.data('packages')) {
    return self.data('packages');
  }

  self.items = []
  self.expanded = false
  self.button = self.find('.packages__see-more')

  self.update = function() {
    self.expanded = false
    self.button.attr('aria-expanded', 'false')
    self.items.forEach(function(item) {
      item.update()
    })
  }

  self.clicked = function() {
    if (self.expanded) {
      self.expanded = false
      self.button.attr('aria-expanded', 'false')
      $('html, body').scrollTo(self.offset().top - $('.header').outerHeight(false) - 32, 450, 5, 'easeInOutQuart')
    } else {
      self.expanded = true
      self.button.attr('aria-expanded', 'true')
      $('html, body').scrollTo(self.find('.package-item__price').first().offset().top - $('.header').outerHeight(false) - 20, 450, 5, 'easeInOutQuart')
    }
    self.items.forEach(function(item) {
      item.clicked()
    })
  }

  return function() {
    self.find('.package-item').each(function() {
      self.items.push($(this).PackagesItem())
    })
    $.mlmi.mobile.add(self.update, self.update)
    self.button.on('click', self.clicked)
    self.data('packages', self);
    return self;
  }();
}
